import type { FunctionComponent } from 'react'
import React from 'react'
import * as playerActions from 'context/player/reducer/player.actions'

import { Slider } from '../PlayerBar.styles'
import {
  CloseButton,
  Container,
  Volume,
  VolumeIcon
} from './ExtraControls.styles'
import { usePlayerContext } from 'context/player'
import { useTranslation } from 'i18n'

const ExtraControls: FunctionComponent = () => {
  const {
    dispatch,
    state: { volume, isMinimized }
  } = usePlayerContext()
  const { t } = useTranslation()

  return (
    <Container>
      <CloseButton
        data-testid="player-close-button"
        aria-label={t('Fechar player')}
        onClick={() => dispatch(playerActions.close())}
        disabled={!isMinimized}
      />
      <Volume>
        <VolumeIcon />
        <Slider
          data-testid="slider-volume"
          aria-label={t('Volume')}
          aria-valuetext={`${volume}%`}
          value={volume}
          onChange={e =>
            dispatch(playerActions.updateVolume(parseInt(e.target.value)))
          }
        />
      </Volume>
    </Container>
  )
}

export default ExtraControls
